import React, { useContext, useRef } from "react";
import {
  // ASSETS_BASE_URL,
  USER_INTERACTION_DEBOUNCE,
} from "../../AppConstants/Constants";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import styles from "./index.module.scss";

const MAX_RATING = 5;
// const starImgFilled = `${ASSETS_BASE_URL}/images/rated.png`;
// const starImgCorner = `${ASSETS_BASE_URL}/images/unrated.png`;

// use for mobile
const CustomRating = ({ giveRating, defaultRating, handleDefaultRating }) => {
  const ratingTimerRef = useRef(null);

  const { user } = useContext(UserContext);

  return (
    <div className={styles.CustomRatingBarStyle}>
      {[...new Array(MAX_RATING)].map((item, key) => {
        let userRate = key + 1;
        return (
          <div
            key={key + 1}
            onClick={() => {
              if (!user) {
                return;
              }
              userRate = key + 1;
              if (key + 1 === defaultRating) {
                userRate = 0;
              }
              handleDefaultRating(userRate);
              if (ratingTimerRef.current) {
                clearTimeout(ratingTimerRef.current);
              }
              ratingTimerRef.current = setTimeout(() => {
                giveRating(userRate);
              }, USER_INTERACTION_DEBOUNCE);
            }}
          >
            {/* <img
              className={styles.ratingImg}
              src={userRate <= defaultRating ? starImgFilled : starImgCorner}
              alt=""
            /> */}
            <svg
              className={styles.ratingImg}
              // width={size}
              // height={size}
              viewBox="0 0 34 33"
            >
              <path
                fill={userRate <= defaultRating ? "#eb4547" : "none"}
                stroke={userRate <= defaultRating ? "#eb4547" : "#fff"}
                strokeWidth="1.5"
                d="M17.6892 26.802L25.5698 31.7948C26.5771 32.433 27.8278 31.4838 27.5289 30.3079L25.252 21.3513C25.1879 21.1018 25.1955 20.8393 25.2739 20.594C25.3523 20.3487 25.4984 20.1304 25.6954 19.9644L32.7621 14.0826C33.6907 13.3098 33.2114 11.7688 32.0184 11.6914L22.7897 11.0924C22.5411 11.0746 22.3027 10.9866 22.1022 10.8386C21.9017 10.6906 21.7474 10.4887 21.6572 10.2564L18.2153 1.58871C18.1217 1.34213 17.9554 1.12984 17.7383 0.980033C17.5212 0.830229 17.2637 0.75 17 0.75C16.7363 0.75 16.4788 0.830229 16.2617 0.980033C16.0446 1.12984 15.8783 1.34213 15.7847 1.58871L12.3428 10.2564C12.2526 10.4887 12.0983 10.6906 11.8978 10.8386C11.6973 10.9866 11.4589 11.0746 11.2103 11.0924L1.98157 11.6914C0.788588 11.7688 0.309328 13.3098 1.23787 14.0826L8.30464 19.9644C8.50158 20.1304 8.64766 20.3487 8.72609 20.594C8.80453 20.8393 8.81212 21.1018 8.74801 21.3513L6.63647 29.6576C6.27778 31.0686 7.77859 32.2076 8.98738 31.4418L16.3108 26.802C16.5167 26.6709 16.7558 26.6012 17 26.6012C17.2442 26.6012 17.4833 26.6709 17.6892 26.802V26.802Z"
              />
            </svg>
          </div>
        );
      })}
    </div>
  );
};

export default CustomRating;
